export const PAGE_NAMES = {
    HOME: 'home',
    CHECKOUT: 'checkout',
    MY_ACCOUNT: 'loyalty'
};
